<template>
  <v-sheet
    class="mx-auto my-5"
    max-width="95%"
  >
    お客様にご処方されたコンタクトレンズは、メーカー販売終了に伴い、当商品をご注文いただくことができません。<br>
    代替レンズのご案内や処方については、以下の販売店またはクリニックまでお問い合わせください。<br>
    <div class="ma-3">
      お問い合わせの際は、
      <span
        v-if="priscription"
        class="ma-3"
      ><b>患者様番号：{{ priscription.patient_patientNumber }}</b></span>をお伝えください。
    </div>

    <div
      v-if="priscription"
      class="ma-5"
    >
      <span v-if="priscription.r_productName">
        {{ $t("右目") }}: {{ priscription.r_productName }}
      </span>

      <v-spacer />
      <span v-if="priscription.l_productName">
        {{ $t("左目") }}: {{ priscription.l_productName }}
      </span>
    </div>
    <div
      v-if="clinic"
      class="ma-5"
    >
      <b>【クリニック情報】<br>
        {{ clinic.name }} </b><br>
      電話番号：{{ clinic.phonenumber }}<br>
      受付時間：{{ clinic.saler_date }}{{ clinic.saler_time }}<br>
    </div>

    <div
      v-if="clinic"
      class="ma-5"
    >
      <b>【販売店情報】<br>
        {{ clinic.saler_name }}</b><br>
      電話番号：{{ clinic.saler_call }}<br>
      受付時間：{{ clinic.saler_date }}{{ clinic.saler_time }}<br>
    </div>
    <p>
      ※同じ度数・種類の代替品が存在しない場合もございます。<br>
      ※眼科での再度の検査・処方が必要な場合がございます。<br>
      何卒ご理解のほどよろしくお願い申し上げます。<br>
    </p>
    <v-spacer />
    <v-btn
      color="primary"
      @click="goBack"
    >
      戻る
    </v-btn>
  </v-sheet>
</template>

<script>
import { Firebase } from "../config/firebase";
export default {
  data() {
    return {
      clinic: null,
      priscription: null,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  created: function () {
    this.fetchPrescriptionById();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    fetchPrescriptionById: async function () {
      console.log(this.id);
      const prescriptionRef = await Firebase.firestore()
        .collection("Prescriptions")
        .doc(this.id);
      await prescriptionRef.get().then((doc) => {
        if (doc.exists) {
          this.priscription = doc.data();
          this.priscription.id = doc.id;
        }
      });

      await this.fetchClinicById();
      console.log(this.prescription);
    },
    fetchClinicById: async function () {
      const clinicRef = await Firebase.firestore()
        .collection("Clinics")
        .doc(this.priscription.clinic_id);
      await clinicRef.get().then((doc) => {
        if (doc.exists) {
          this.clinic = doc.data();
          this.clinic.id = doc.id;
        } else {
          console.log("No clinic document!");
        }
        this.error = true;
      });
    },
  },
};
</script>
